import { useOrchestratorApi } from '@/composables/orchestrator/useOrchestratorApi'
import useWebsocket from '../useWebsocket'
import { useWorkflow } from '@/composables/workflow/useWorkflow'
import { logger } from '@sentry/vue'
import { SESSION_EXPIRED } from '../../types'
import type { SessionContext, SessionStrategy } from '../../types'
import {
    awaitFirstView,
    advance,
    changeLanguage,
    currentTaskEvents,
    disposeSession,
    latestTaskEvent,
    resetRun,
    resolveLayout,
    watchWorkflowEnd,
} from './shared'

const TERMINAL_WORKFLOW_STATUSES = [
    'COMPLETED',
    'FAILED',
    'TIMEOUT',
    'TERMINATED',
    'PAUSED',
]

export const createTokenV1V2Strategy = (): SessionStrategy => ({
    kind: 'token-v1v2',

    preConnect: async () => {},

    validateSession: async (ctx: SessionContext) => {
        await useWorkflow().validateToken(ctx.token)
        logger.trace(`T0ken validated`)
    },

    resolveWorkflow: async () => {
        const workflow = await useWorkflow().getCurrentWorkflow()

        logger.trace(`Get workflow for the current run`)

        if (TERMINAL_WORKFLOW_STATUSES.includes(workflow?.status || 'no-status')) {
            throw new Error(SESSION_EXPIRED)
        }
    },

    ensureConnected: async (ctx: SessionContext) => {
        const { workflowId } = useWorkflow()

        await useWebsocket().initialize(ctx.token, `${workflowId.value}`, ctx.mode)
    },

    start: async () => {
        const { workflowId, token } = useWorkflow()

        await useOrchestratorApi().put(
            `/workflows/${workflowId.value}`,
            {
                Authorization: `Bearer ${token.value}`,
            },
        )
    },

    awaitFirstView,
    advance,
    changeLanguage,
    resolveLayout,
    engineApi: useOrchestratorApi,
    currentTaskEvents,
    latestTaskEvent,
    watchWorkflowEnd,
    resetRun,
    disposeSession,
})
